import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import moment from "moment";
import { actionEmployerQuoteList, resetEmployerQuoteList } from "../store";
import { DataGrid } from "devextreme-react";
import {
  Column,
  Export,
  FilterRow,
  SearchPanel,
  HeaderFilter,
} from "devextreme-react/cjs/data-grid";
import ListDateFilters from "../../../../../component/filters/list_date_filters";
import ListCalendarFilter from "../../../../../component/filters/list_calendar_filter";
import { getLocalStorageItem, onExporting } from "../../../../../utils";
import BulkUpload from "../../../../../component/bulk_upload";
import toast from "react-hot-toast";
import Loader from "../../../../../component/page_loader";
import {
  TOAST_DURATION,
  TOAST_ERROR_COLOR,
  TOAST_POSITION,
} from "../../../../../common/app_constant";
import { useForm } from "react-hook-form";
import { SUB_DIRECTORY } from "../../../../../common/constant";

const EmployerQuoteList = () => {
  const { register, watch } = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const [viewEmployerQuoteList, setViewEmployerQuoteList] = useState();
  const [uploadBulk, setUploadBulk] = useState(false);
  const [role, setRole] = useState();
  const [isLoader, setIsLoader] = useState(true);
  const watchRenewalStatus = watch("renewal_status");

  const { EmployerQuoteList } = useSelector(state => ({
    ...state.listStore,
  }));

  // Function to update fromDate in the parent component
  const updateFromDate = newFromDate => {
    setFromDate(newFromDate);
  };
  // Function to update toDate in the parent component
  const updateToDate = newToDate => {
    setToDate(newToDate);
  };
  // Function to final fromDate in the parent component
  const finalFromDate = newFromDate => {
    fromDate(newFromDate);
  };
  // Function to final toDate in the parent component
  const finalToDate = newToDate => {
    toDate(newToDate);
  };

  const receivedData = location.state?.data || null;
  //Reset function
  const handleResetClick = () => {
    setFromDate(initialFromDate); // Reset fromDate to its initial value
    setToDate(initialToDate); // Reset fromDate to its initial value
  };
  // inital FromDate and to date
  const initialFromDate = receivedData?.from
    ? moment(receivedData?.from).format("YYYY-MM-DD")
    : // : moment(new Date()).subtract(2, "month").format("YYYY-MM-DD")
    "";
  const initialToDate = receivedData?.to
    ? moment(receivedData?.to).format("YYYY-MM-DD")
    : // : moment(new Date()).add(4, "month").format("YYYY-MM-DD")
    "";

  //   take updated date in state
  const [fromDate, setFromDate] = useState(initialFromDate);
  const [toDate, setToDate] = useState(initialToDate);

  // for renewal due days
  const renderDaysCell = date => {
    const daysRemaining =
      moment(date).isValid() &&
      moment(date, "YYYY/MM/DD").diff(moment(), "days");
    return daysRemaining;
  };

  // Make and Modal render cell
  const renderMakeModal = data => {
    // Access the necessary data properties from the data object
    const field1 = data.make; // Assuming field1 is one of the fields you want to merge
    const field2 = data.model; // Assuming field2 is the other field you want to merge

    // Merge the fields (example: concatenating them)
    const mergedValue = `${field1} - ${field2}`;

    // Return the merged value
    return mergedValue;
  };

  useEffect(() => {
    dispatch(
      actionEmployerQuoteList({
        from_date: fromDate,
        to_date: toDate,
        renewal_status: watchRenewalStatus === "All" ? "" : watchRenewalStatus,
      })
    );
  }, [watchRenewalStatus]);
  // for api call
  useEffect(() => {
    setRole(getLocalStorageItem("next"));
    dispatch(actionEmployerQuoteList({
      from_date: fromDate,
      to_date: toDate,
      renewal_status: watchRenewalStatus === "All" ? "" : watchRenewalStatus,
    }));
  }, []);

  // fetch data in table list (for acknowledgment)
  useEffect(() => {
    dispatch(resetEmployerQuoteList());
    if (EmployerQuoteList != null) {
      if (EmployerQuoteList.status == true) {
        setIsLoader(false);
        setViewEmployerQuoteList(EmployerQuoteList.data);
      } else {
        setIsLoader(false);
        switch (EmployerQuoteList.status_code) {
          case 400:
            toast.error(EmployerQuoteList.message, {
              duration: TOAST_DURATION,
              position: TOAST_POSITION,
              style: {
                color: TOAST_ERROR_COLOR,
              },
            });
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          case 401:
            localStorage.clear();
            navigate("/login", { replace: true });
            break;
          default:
        }
      }
    }
  }, [EmployerQuoteList]);
  // api call on date change
  useEffect(() => {
    dispatch(
      actionEmployerQuoteList({
        from_date: fromDate,
        to_date: toDate,
        renewal_status: watchRenewalStatus === "All" ? "" : watchRenewalStatus,
      })
    );
  }, [toDate, fromDate]);

  // Render action -edit
  const renderAction = data => (
    <>
      {role == "copsdashboard" && (
        <button
          className={`btn btn-sm btn-primary cursor-pointer`}
          onClick={() => {
            // redirection in same window
            // if (data) {
            //   console.log(JSON.stringify(data));
            //   navigate("/employer/quote-update", { state: { data: data } });
            // }

            // redirection in new window
            localStorage.setItem("detailsData", JSON.stringify(data));
            const url = `/employer/quote-update`;

            const win = window.open(url, "_blank");
            if (win) {
              win.focus();
            } else {
              console.log(
                "Pop-up blocked. Please allow pop-ups for this site."
              );
            }
          }}
        >
          Edit
        </button>
      )}
      {role != "employerdashboard"
        && (
          <button
            className={`btn btn-sm btn-primary cursor-pointer mx-1`}
            onClick={() => {
              localStorage.setItem("detailsData", JSON.stringify(data));
              const url = `/employer/quote-details`;

              const win = window.open(url, "_blank");
              if (win) {
                win.focus();
              } else {
                console.log(
                  "pop-up blocked.please allow pop-ups for this site."
                );
              }
            }}
          >
            View
          </button>
        )}
    </>
  );

  return (
    <>
      <div className="row justify-content-center pb-5 mt-6">
        <div className="col-12 mb-5">
          <div className="d-flex justify-content-between mb-2">
            <div className="">
              <h5 className="mb-0">Quote List</h5>
            </div>
            <div>
              {role == "copsdashboard" && (
                <>
                  <button
                    className={`btn btn-sm btn-primary cursor-pointer me-2`}
                    onClick={() => {
                      localStorage.removeItem("detailsData");
                      navigate("/employer/quote-update");
                    }}
                  >
                    Add
                  </button>
                  <button
                    className={`btn btn-sm btn-primary cursor-pointer`}
                    onClick={() => {
                      setUploadBulk(true);
                    }}
                  >
                    Add Bulk
                  </button>
                </>
              )}
            </div>
          </div>

          {/* renewal date filter */}
          <ListDateFilters
            lebel1={"Renewal Date From"}
            lebel2={"Renewal Date To"}
            updateFromDate={updateFromDate}
            updateToDate={updateToDate}
            resetClick={handleResetClick}
            fromDate={fromDate}
            toDate={toDate}
          />
          {isLoader === true ? (
            <Loader />
          ) : (
            <div className="card border mt-3">
              <div className="card-header">
                {/* calender filter component */}
                <ListCalendarFilter
                  updateFromDate={updateFromDate}
                  updateToDate={updateToDate}
                  finalFromDate={finalFromDate}
                  finalToDate={finalToDate}
                />
              </div>
              {/* Renewal status Filter */}

              <div className="card-body position-relative">
                <div className="position-absolute w-25 z-index-9 ">
                  <select
                    class="form-select fw-bold text-primary"
                    name="renewal_status"
                    {...register("renewal_status")}
                    aria-label="select example"
                  >
                    {[
                      "All",
                      "Pending",
                      "Quote Confirm",
                      "Under Process",
                      "Success",
                      "Lost",
                      "Closed"
                    ].map(option => (
                      <option key={option} value={option}>
                        {option} {watch('renewal_status') === option && `(${viewEmployerQuoteList?.length})`}
                      </option>
                    ))}
                  </select>
                </div>
                <DataGrid
                  id="quote_list"
                  dataSource={viewEmployerQuoteList}
                  columnMinWidth={100}
                  showBorders={true}
                  filterSyncEnabled={false}
                  allowColumnResizing={true}
                  columnAutoWidth={true}
                  onExporting={onExporting}
                >
                  <SearchPanel visible={true} />
                  <HeaderFilter visible={true} />
                  <FilterRow visible={true} />
                  {(role == "copsdashboard" || role == "superuserdashboard") && (
                    <Column
                      dataField="action"
                      caption="Action"
                      cellRender={({ data }) => renderAction(data)}
                    />
                  )}
                  <Column
                    dataField="index"
                    caption="S.No"
                    dataType="number"
                    cellRender={rowData => {
                      return rowData?.rowIndex != null
                        ? Number(rowData?.rowIndex + 1)
                        : "-";
                    }}
                  />
                  {/* <Column dataField="id" caption="ID" /> */}
                  <Column dataField="quote_type" caption="Type" />
                  <Column
                    dataField="userDetails.full_name"
                    caption="EMP Name "
                  />
                  <Column
                    dataField="userDetails.userCity.cityState.stateZone.name"
                    caption="Emp Zone"
                  />

                  {/* Previous Policy No */}
                  <Column
                    dataField="previous_policy_no"
                    caption="Policy No. "
                  />
                  <Column
                    dataField=""
                    caption="Policy Expiry Date"
                    cellRender={({ data }) =>
                      data.quote_type === "New"
                        ? data.formatted_new_policy_end_date || "-"
                        : data.formatted_previous_policy_end_date || "-"
                    }
                  />

                  <Column
                    dataField="previous_policy_end_date"
                    caption="Renewal Due Days"
                    cellRender={({ data }) => 
                    data.quote_type === "New"
                    ? data.formatted_new_policy_end_date || "-"
                    : data.formatted_previous_policy_end_date || "-"
                }
                  />
                  <Column dataField="policy_sub_type" caption="Policy Type" />
                  {/* Vehicle Make & Model */}
                  <Column
                    dataField=""
                    caption="Vehicle Details"
                    cellRender={({ data }) => renderMakeModal(data)}
                  />
                  <Column dataField="current_total_idv" caption="Current IDV" />
                  <Column
                    dataField="current_year_ncb"
                    caption="Current NCB (%)"
                  />
                  {/* Previous Insurer Name */}
                  <Column
                    dataField="renewal_plan_final"
                    caption="Add On Plan"
                    cellRender={({ data }) =>
                      data.renewal_plan_final ? data.renewal_plan_final : "No"
                    }
                  />
                  <Column
                    dataField="renewal_final_amt"
                    caption="Final Premium"
                    cellRender={({ data }) =>
                      data.renewal_final_amt ? data.renewal_final_amt : "-"
                    }
                  />
                  <Column
                    dataField="renewal_status"
                    caption="Current Status"
                    cellRender={({ data }) =>
                      data.renewal_status ? data.renewal_status : "-"
                    }
                  />
                  <Column dataField="paid_through" caption="Paid By" />
                  <Column
                    dataField="formatted_renewal_confirm_date"
                    caption="Quote Confirm Date"
                  />
                  <Column caption="Exiting IDV" dataField="expiring_idv_vne" />
                  <Column dataField="expiring_ncb" caption="Expiring NCB %" />
                  <Column
                    dataField="previous_add_on_value"
                    caption="Expiring Plan"
                  />

                  <Column
                    dataField="policyDetails.gross_premium"
                    caption="Expiring Premium"
                  />

                  {/* only default plan need to show sr. 45 */}

                  {/* <Column dataField="Default premium" caption="Default Add On Premium (need to do calculation in FE Side)"
                /> */}

                  {/* only selected plan need to show 91 92 need to calculate*/}

                  <Column
                    dataField="lastUpdatedBy.full_name"
                    caption="Last Modified By"
                  />
                  <Column
                    dataField="lastUpdatedBy.formatted_updated_at"
                    caption="Last Modified Date"
                  />

                  <Export enabled={true} />
                </DataGrid>
              </div>
            </div>
          )}
        </div>
      </div>
      <BulkUpload
        sampleFileName={`${SUB_DIRECTORY}/documents/quotes data.csv`}
        show={uploadBulk}
        module="quote"
        dynamic_url="quote/upload"
        handleUpdateList={() => {
          setUploadBulk(false);
          dispatch(
            actionEmployerQuoteList({
              from_date: fromDate,
              to_date: toDate,
              renewal_status: watchRenewalStatus === "All" ? "" : watchRenewalStatus,
            })
          );
        }}
      />
    </>
  );
};

export default EmployerQuoteList;
